<template>
    <PrivacyPolicyListing />
</template>
<script>
import PrivacyPolicyListing from "@/views/pages/public/privacyPolicy/privacyPolicyListing";

export default {
    page: {
        title: "Privacy Policy",
    },
    components: { PrivacyPolicyListing },
}
</script>
